<app-pseudo-link *ngIf="isTranslated || canTranslate" (click)="onClick()">
  {{ labelKey | locCap }}
</app-pseudo-link>

